
import { Component, Vue } from 'vue-property-decorator';
import { changeFavicon } from '@/utils/styling';
import { buildPageMetaInfo } from '@/utils/meta';
import concoursesList from '../concourses.data.json';
import axios from 'axios';
import 'vue-select/dist/vue-select.css';

type ConcourseItem = {
	id: number,
	name: string,
	address: string,
	url: string,
	label?: string
}

@Component<Concourses>({
	metaInfo() {
		changeFavicon(`${process.env.VUE_APP_IMAGE_BUCKET}/a-table/favicon.png`);

		return buildPageMetaInfo('App8 Restaurant');
	}
})
export default class Concourses extends Vue {
	private concourses: ConcourseItem[] = [];
	private searchField: ConcourseItem|null = null;

	private get aTableLogo(): string {
		return `${process.env.VUE_APP_IMAGE_BUCKET}/a-table/a-table-logo.png`;
	}

	private get aTableHeroImage(): string {
		return `${process.env.VUE_APP_IMAGE_BUCKET}/a-table/hero-background.png`;
	}

	private get aTableContentImage(): string {
		return `${process.env.VUE_APP_IMAGE_BUCKET}/a-table/content-image.png`;
	}

	private get concoursesWithLabel(): ConcourseItem[] {
		return this.concourses.map(concourse => {
			return {
				...concourse,
				label: concourse.name + ' ' + concourse.address
			};
		});
	}

	private async created(): Promise<void> {
		if(process.env.NODE_ENV === 'development') {
			this.concourses = concoursesList;
		}
		else {
			const url: string = window.location.href;
			if (!url.includes('a-table.ca')) {
				this.$router.replace({ name: 'PageNotFound' }).catch(() => {});
			}
			const response = await axios.get<ConcourseItem[]>(`${window.location.origin}/a-table/concourses.data.json`);
			this.concourses = response.data;
		}
	}

	/**
	 * Redirect to the selected concourse
	 *
	 * @param {ConcourseItem} selectedConcourse
	 * @return {void}
	 */
	private selectConcourse(selectedConcourse: ConcourseItem): void {
		window.location.href = selectedConcourse.url;
	}
}
